import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import {
  DEFAULT_NAMESPACE,
  LANGUAGES,
  NAMESPACES,
  RESOURCES,
} from "@/constants/i18next.constants";
import { isDevelopment } from "@/constants/isDevelopement";

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector) // language detector
  .init({
    supportedLngs: Object.values(LANGUAGES),
    debug: isDevelopment,
    ns: Object.values(NAMESPACES),
    defaultNS: DEFAULT_NAMESPACE,
    resources: RESOURCES,
    fallbackLng: LANGUAGES.TR,
  });

export default i18next;
